/**
 * "Am I on the wide layout?" as a hook, because some of this design is a different TREE and not
 * just different CSS.
 *
 * Most breakpoint work belongs in the stylesheet and stays there. Two things on Draft › Order and
 * lottery genuinely cannot: the ranking is a list of what you have ranked on a phone and a grid of
 * all ten positions with `empty` in the gaps on a desktop, and the same counter is labelled
 * "Ranked / rank all ten to be safe" on one and "Your ranking / best first · drag to reorder" on
 * the other. Rendering both and hiding one with CSS would read every label twice to a screen
 * reader, which is the accessibility bug that trade costs nothing to avoid.
 *
 * Falls to the narrow layout when `matchMedia` is missing, so a server or a test environment gets
 * the phone tree rather than a crash.
 */

import { useEffect, useState } from 'react';

export function useMinWidth(px: number): boolean {
  const query = `(min-width: ${px}px)`;
  const [wide, setWide] = useState(
    () => typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      && window.matchMedia(query).matches,
  );
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia(query);
    const on = () => setWide(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return wide;
}
